const Backbone = require('backbone');
var InventoryView = Backbone.View.extend({
	el: '#stock-count',

	initialize: function(options) {
		this.options = Object.assign({}, options);
		this.listenTo(Backbone, 'finish:clicked', this.updateStock);
	},

	updateStock: function(data) {
		if (data.hideStock || !this.options.model.isPreConfigured()) {
			this.$el.addClass('hidden');
		} else {
			this.$el.removeClass('hidden');
			var text = data.stock > 0 ? `${data.stock} In Stock` : 'Out Of Stock';
			this.$el.html(text);
			if (data.stock > 0) {
				this.$el.removeClass('text-red');
				this.$el.addClass('text-accent');
			} else {
				this.$el.removeClass('text-accent');
				this.$el.addClass('text-red');
			}
		}
	}
});

module.exports = InventoryView;
